var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconMall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.83334L7.26 9.34001C7.47911 9.4862 7.7366 9.56421 8 9.56421C8.2634 9.56421 8.52089 9.4862 8.74 9.34001L14 5.83334M3.33333 13.1667H12.6667C13.0203 13.1667 13.3594 13.0262 13.6095 12.7762C13.8595 12.5261 14 12.187 14 11.8333V5.16668C14 4.81305 13.8595 4.47392 13.6095 4.22387C13.3594 3.97382 13.0203 3.83334 12.6667 3.83334H3.33333C2.97971 3.83334 2.64057 3.97382 2.39052 4.22387C2.14048 4.47392 2 4.81305 2 5.16668V11.8333C2 12.187 2.14048 12.5261 2.39052 12.7762C2.64057 13.0262 2.97971 13.1667 3.33333 13.1667Z",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconMall);
export default __webpack_public_path__ + "static/media/common_icon_mall.8db6af41fe851d13bc9dfe6f66428978.svg";
export { ForwardRef as ReactComponent };